import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesProfiles = {
  id: '',
  description: '',
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageProfiles = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesProfiles}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageProfiles.displayName = 'Page profiles initializer component';

export default PageProfiles;
